/**
 * @imports
 */
import React from 'react'
import Page from '../../components/View'
import { Tag } from 'antd'
import { PagosSolicitadosCxp } from '../Cxp/pagosSolicitados'
import { PagosSolicitadosSub } from '../Sub/Components/pagosSolicitados'

export default class PagosSolicitados extends React.Component {
  constructor(props) {
    super(props)
    this.state = { tabKey: 'compras' }
  }

  /**
   * Render
   */
  render() {
    const { tabKey } = this.state
    const tabComprasActive = tabKey === 'compras'
    const tabServiciosActive = tabKey === 'servicios'

    return (
      <Page>
        <div style={{ padding: 25, flex: 1, display: 'flex', flexDirection: 'column', overflowY: 'auto' }}>
          <div style={{ marginBottom: 25 }}>
            <h1 style={{ margin: 0 }}>Solicitudes de pago</h1>
            <label>SEGUIMIENTO DE PAGO POR COMPRAS O SERVICIOS REALIZADOS</label>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', marginBottom: 10 }}>
            <Tag
              children='MATERIALES'
              color={tabComprasActive ? 'blue' : undefined}
              onClick={() => this.setState({ tabKey: 'compras' })}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            />

            <Tag
              children='SUBCONTRATOS Y SERVICIOS'
              color={tabServiciosActive ? 'blue' : undefined}
              onClick={() => this.setState({ tabKey: 'servicios' })}
              style={{ cursor: 'pointer', fontWeight: 'bold' }}
            />
          </div>

          {!tabComprasActive ? null :
            <PagosSolicitadosCxp />
          }

          {!tabServiciosActive ? null :
            <PagosSolicitadosSub />
          }

          {/* <Tabs defaultActiveKey="1" onChange={onTabChange} style={{ marginLeft: 10, marginRight: 10, flex: 1 }}>
            <TabPane tab="COMPRAS" key="1">
              <PagosSolicitadosCxp />
            </TabPane>
            <TabPane tab="SERVICIOS" key="2">
              Content of Tab Pane 2
            </TabPane>
          </Tabs> */}
        </div>
      </Page>
    )
  }
}
